import React, { useEffect, useState } from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import Loading from "../../../components/common/Loading";
import { Oval } from "react-loader-spinner";

// const faqData = [
//   {
//     question: "It is a long established reader will be?",
//     answer:
//       "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.",
//   },
//   {
//     question: "Distracted by the readable page whent?",
//     answer:
//       "It has survived not only five centuries, but also the leap into electronic typesetting. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.",
//   },
//   {
//     question: "What is user interface kit?",
//     answer:
//       "It has survived not only five centuries, but also the leap into electronic typesetting. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.",
//   },
//   {
//     question: "The readable content layout?",
//     answer:
//       "It has survived not only five centuries, but also the leap into electronic typesetting. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.",
//   },
//   {
//     question: "The readable content of a page at its layout?",
//     answer:
//       "It has survived not only five centuries, but also the leap into electronic typesetting. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.",
//   },
//   {
//     question: "What is user interface kit?",
//     answer:
//       "It has survived not only five centuries, but also the leap into electronic typesetting. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.",
//   },
//   {
//     question: "The readable content and survived?",
//     answer:
//       "It has survived not only five centuries, but also the leap into electronic typesetting. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.",
//   },
//   {
//     question: "The readable content of a page layout?",
//     answer:
//       "It has survived not only five centuries, but also the leap into electronic typesetting. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.",
//   },
//   {
//     question: "Distracted by readable content of a page?",
//     answer:
//       "It has survived not only five centuries, but also the leap into electronic typesetting. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.",
//   },
// ];

const faqData = [
  {
    question: "How can I view my enrolled courses?",
    answer:
      "You can view all your enrolled courses by navigating to the 'My Courses' section on the dashboard. Each course includes details like duration, instructors, and schedule.",
  },
  {
    question: "Where can I check my attendance?",
    answer:
      "Attendance records are available under each course?. Go to the course page and select the 'Attendance' tab to view your attendance summary and detailed logs.",
  },
  {
    question: "How do I access training materials or assignments?",
    answer:
      "All training materials and assignments are available in the 'Resources' or 'Assignments' tab within the respective course?. Files can be downloaded or accessed online.",
  },
  {
    question: "Where is the lesson plan located?",
    answer:
      "Lesson plans are included in each course's overview section. You can find detailed weekly or session-wise lesson outlines there.",
  },
  {
    question: "How can I check my exam scores?",
    answer:
      "Exam scores are listed in the 'Grades' or 'Assessments' section within each course?. You’ll also receive notifications when new results are published.",
  },
  {
    question: "How can I find upcoming courses or lesson plans?",
    answer:
      "Upcoming courses and lessons are listed in the 'Upcoming' section of your dashboard. You can also explore the course catalog for new enrollment opportunities.",
  },
  {
    question:
      "How can I send a query to the course instructor or support team?",
    answer:
      "To send a query, go to the 'Help' or 'Contact Us' section. You can submit a message directly to the instructor or support team and track responses.",
  },
  {
    question: "Where can I find notifications from the organization?",
    answer:
      "Notifications are visible in the 'Notifications' tab in the top navigation bar. Important announcements, deadlines, and course updates will appear there.",
  },
];

const Faq = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  }, []);

  return (
    <div
      id="content-page"
      className="content-inner py-5"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <Container id="faqAccordion" style={{ maxWidth: "900px" }}>
        {loading
          ? <>
            <div
              className="d-flex justify-content-center "
              style={{ height: "85vh", paddingTop: "15vh" }}
            >
              <Oval
                height="50"
                width="50"
                color="#4fa94d"
                secondaryColor="#4fa94d"
              />
            </div>
          </>
          : (
            <>
              <Row>
                <Col lg="12" className="mb-5">
                  <div className="bg-primary text-white text-center py-4 px-3 rounded shadow-sm">
                    <h2 className="mb-2 text-white fw-bold">
                      Frequently Asked Questions
                    </h2>
                    <p className="mb-0" style={{ lineHeight: "1.6" }}>
                      Find answers to the most commonly asked questions about our
                      services.
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <Accordion id="accordionExample" defaultActiveKey="0">
                    {faqData.map((item, index) => (
                      <Accordion.Item
                        className="mb-3 border-0 shadow-sm rounded"
                        eventKey={index.toString()}
                        key={index}
                      >
                        <Accordion.Header>
                          <strong style={{ fontSize: "1.05rem" }}>
                            {item.question}
                          </strong>
                        </Accordion.Header>
                        <Accordion.Body
                          style={{ fontSize: "0.95rem", color: "#555" }}
                        >
                          {item.answer}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </Col>
              </Row>
            </>
          )
        }
      </Container>
    </div>
  );
};

export default Faq;

// import React from "react";
// import { Container, Row, Col, Accordion, Card } from "react-bootstrap";

// const Faq = () => {
//   return (
//     <>
//       <div id="content-page" className="content-inner">
//         <Container id="faqAccordion">
//           <Row>
//             <Col lg="12" className="mb-4">
//               <div className="bg-primary text-white text-center py-4 rounded shadow">
//                 <h2 className="mb-0 text-white">Frequently Asked Questions</h2>
//                 <p className="mb-0 px-2 mt-2" style={{ lineHeight: "1.4" }}>
//                   Find answers to the most commonly asked questions about our
//                   services.
//                 </p>
//               </div>
//             </Col>
//           </Row>
//           <Row>
//             <Col lg="12">
//               <Accordion id="accordionExample" defaultActiveKey="0">
//                 <Accordion.Item className="mb-3" eventKey="0">
//                   <Accordion.Header id="heading1">
//                     It is a long established reader will be?
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <p>
//                       Many desktop publishing packages and web page editors now
//                       use Lorem Ipsum as their default model text, and a search
//                       for 'lorem ipsum' will uncover many web sites still in
//                       their infancy.
//                     </p>
//                   </Accordion.Body>
//                 </Accordion.Item>
//                 <Accordion.Item className="mb-3" eventKey="1">
//                   <Accordion.Header id="heading2">
//                     Distracted by the readable page whent?
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <p>
//                       It has survived not only five centuries, but also the leap
//                       into electronic typesetting. Neque porro quisquam est, qui
//                       dolorem ipsum quia dolor sit amet, consectetur.
//                     </p>
//                   </Accordion.Body>
//                 </Accordion.Item>
//                 <Accordion.Item className="mb-3" eventKey="2">
//                   <Accordion.Header id="heading3">
//                     What is user interface kit?
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <p>
//                       It has survived not only five centuries, but also the leap
//                       into electronic typesetting. Neque porro quisquam est, qui
//                       dolorem ipsum quia dolor sit amet, consectetur.
//                     </p>
//                   </Accordion.Body>
//                 </Accordion.Item>
//                 <Accordion.Item className="mb-3" eventKey="3">
//                   <Accordion.Header id="heading4">
//                     The readable content layout?
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <p>
//                       It has survived not only five centuries, but also the leap
//                       into electronic typesetting. Neque porro quisquam est, qui
//                       dolorem ipsum quia dolor sit amet, consectetur.
//                     </p>
//                   </Accordion.Body>
//                 </Accordion.Item>
//                 <Accordion.Item className="mb-3" eventKey="4">
//                   <Accordion.Header id="heading5">
//                     The readable content of a page at its layout?
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <p>
//                       It has survived not only five centuries, but also the leap
//                       into electronic typesetting. Neque porro quisquam est, qui
//                       dolorem ipsum quia dolor sit amet, consectetur.
//                     </p>
//                   </Accordion.Body>
//                 </Accordion.Item>
//                 <Accordion.Item className="mb-3" eventKey="5">
//                   <Accordion.Header id="heading6">
//                     What is user interface kit?
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <p>
//                       It has survived not only five centuries, but also the leap
//                       into electronic typesetting. Neque porro quisquam est, qui
//                       dolorem ipsum quia dolor sit amet, consectetur.
//                     </p>
//                   </Accordion.Body>
//                 </Accordion.Item>
//                 <Accordion.Item className="mb-3" eventKey="6">
//                   <Accordion.Header id="heading7">
//                     The readable content and survived?
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <p>
//                       It has survived not only five centuries, but also the leap
//                       into electronic typesetting. Neque porro quisquam est, qui
//                       dolorem ipsum quia dolor sit amet, consectetur.
//                     </p>
//                   </Accordion.Body>
//                 </Accordion.Item>
//                 <Accordion.Item className="mb-3" eventKey="7">
//                   <Accordion.Header id="heading8">
//                     The readable content of a page layout?
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <p>
//                       It has survived not only five centuries, but also the leap
//                       into electronic typesetting. Neque porro quisquam est, qui
//                       dolorem ipsum quia dolor sit amet, consectetur.
//                     </p>
//                   </Accordion.Body>
//                 </Accordion.Item>
//                 <Accordion.Item className="mb-3" eventKey="8">
//                   <Accordion.Header id="heading9">
//                     Distracted by readable content of a page?
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <p>
//                       It has survived not only five centuries, but also the leap
//                       into electronic typesetting. Neque porro quisquam est, qui
//                       dolorem ipsum quia dolor sit amet, consectetur.
//                     </p>
//                   </Accordion.Body>
//                 </Accordion.Item>
//               </Accordion>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </>
//   );
// };

// export default Faq;
